import { MAX_SLIPPAGE } from "consts";
import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";
import { MIN_SLIPPAGE } from "consts";
import { useRef } from "react";
import { useState } from "react";
import {
  DEFAULT_CACHED_SLIPPAGE,
  DEFAULT_CACHED_VALIDATOR_TIP,
} from "store/user-store-v2/useUserStoreV2";
import axiosService from "services/axios";
import { DEFAULT_CACHED_PRIORITY_FEE } from "store/user-store-v2/useUserStoreV2";
import { useTheme } from "@mui/material";

const withPreferencesDrawer = (Component: React.ComponentType<any>) => {
  return ({
    isOpen,
    close,
    showPriorityFee,
    showValidatorTip,
  }: {
    isOpen: boolean;
    close: () => void;
    showPriorityFee: boolean;
    showValidatorTip: boolean;
  }) => {
    const {
      preferences = {
        slippage: DEFAULT_CACHED_SLIPPAGE,
        validatorTip: DEFAULT_CACHED_VALIDATOR_TIP,
        priorityFee: DEFAULT_CACHED_PRIORITY_FEE,
      },
      setPreferences,
    } = useUserStoreV2();
    const {
      slippage = DEFAULT_CACHED_SLIPPAGE,
      validatorTip = DEFAULT_CACHED_VALIDATOR_TIP,
      priorityFee = DEFAULT_CACHED_PRIORITY_FEE,
    } = preferences;

    const theme = useTheme();
    const [isSlippageValid, setIsSlippageValid] = useState(!!slippage);
    // const [isValidatorTipValid, setIsValidatorTipValid] = useState(!!validatorTip);
    // const [isPriorityFeeValid, setIsPriorityFeeValid] = useState(!!priorityFee);
    const [isShowTips, setIsShowTips] = useState(false);
    const [slippageValue, setSlippageValue] = useState(slippage);
    const [validatorTipValue, setValidatorTipValue] = useState(validatorTip);

    const slippageRef = useRef<HTMLInputElement>(null);
    const validatorTipRef = useRef<HTMLInputElement>(null);
    const priorityFeeRef = useRef<HTMLInputElement>(null);

    const handleSlippageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const value = parseFloat(event.target.value);
        slippageRef.current!.value = value === 0 ? event.target.value : value.toString();
        setIsSlippageValid(() => !isNaN(value) && value >= MIN_SLIPPAGE && value <= MAX_SLIPPAGE);
        setSlippageValue(value);
      } catch (error) {
        console.error(error);
      }
    };

    const handleValidatorTipChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const value = parseFloat(event.target.value);
        validatorTipRef.current!.value = value === 0 ? event.target.value : value.toString();
        setValidatorTipValue(value);
        setIsShowTips(value > parseFloat(priorityFeeRef.current!.value));

        // setIsValidatorTipValid(
        //   () => !isNaN(value) && value >= MIN_VALIDATOR_TIP && value <= MAX_VALIDATOR_TIP,
        // );
      } catch (error) {
        console.error(error);
      }
    };

    const handlePriorityFeeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      try {
        const value = parseFloat(event.target.value);
        priorityFeeRef.current!.value = value === 0 ? event.target.value : value.toString();
        setIsShowTips(parseFloat(validatorTipRef.current!.value) > value);
        // setIsPriorityFeeValid(
        //   () => !isNaN(value) && value >= MIN_PRIORITY_FEE && value <= MAX_PRIORITY_FEE,
        // );
      } catch (error) {
        console.error(error);
      }
    };

    const handleConfirmPreferences = async () => {
      try {
        if (!slippageRef.current && !validatorTipRef.current && !priorityFeeRef.current) {
          return;
        }

        const slippageValue = parseFloat(slippageRef.current?.value ?? slippage!.toString());
        const validatorTipValue = parseFloat(
          validatorTipRef.current?.value ?? validatorTip!.toString(),
        );
        const priorityFeeValue = parseFloat(
          priorityFeeRef.current?.value ?? priorityFee!.toString(),
        );
        await axiosService.updateUserPreferences({
          slippage: slippageValue,
          validatorTip: validatorTipValue,
          priorityFee: priorityFeeValue,
        });

        setPreferences(slippageValue, validatorTipValue, priorityFeeValue);
        close();
      } catch (error) {
        console.error(error);
      }
    };

    return (
      <Component
        isOpen={isOpen}
        close={close}
        slippageRef={slippageRef}
        handleSlippageChange={handleSlippageChange}
        slippage={slippageValue}
        showValidatorTip={showValidatorTip}
        validatorTipRef={validatorTipRef}
        handleValidatorTipChange={handleValidatorTipChange}
        validatorTip={validatorTipValue}
        isShowTips={isShowTips}
        isSlippageValid={isSlippageValid}
        handleConfirmPreferences={handleConfirmPreferences}
      />
    );
  };
};

export default withPreferencesDrawer;
